module.exports = __webpack_public_path__ + "static/media/animated_lahiru.02ab494e.png";